import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMSubdomainUrlHelper {
  static businessBaseUrl() {
    return SMRailsBridge.subdomainUrl.BusinessUrl;
  }

  static businessSummaryUrl(username) {
    return `${this.businessBaseUrl()}/companies/${username}/summaries`;
  }
}

export default SMSubdomainUrlHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMSubdomainUrlHelper.js